// Malay (Bahasa Malaysia, "anda") copy for /on-demand-ftp, translated from copy.en.ts. Same shape (checked by
// copy.test.ts). "FTP atas permintaan", "pemuat naik web" and "ruang kerja" as in the site's ms locale.
// The uploader's and FileZilla's own labels are in English, so «labels» are quoted as the app shows them.
import type { OnDemandFtpCopy } from "./copy.en";

const ms: OnDemandFtpCopy = {
  seo: {
    title: "Cara FTP atas permintaan berfungsi | Photohawk",
    description:
      "Jika FTP amat diperlukan, setiap ahli ruang kerja anda boleh memulakan pelayan FTP Photohawk mereka sendiri daripada pemuat naik web, pada semua pelan. Sedia dalam kira-kira 30 saat, pada alamat peribadi yang tidak pernah berubah, dan ia dimatikan sendiri selepas sejam tanpa aktiviti.",
  },
  hero: {
    badge: "Semua pelan",
    eyebrow: "Tersedia sekarang",
    title: "Cara FTP atas permintaan berfungsi",
    subtitle:
      "Jika FTP amat diperlukan, mulakan pelayan FTP anda sendiri daripada pemuat naik web bila-bila masa anda perlukannya. Ia sedia dalam kira-kira 30 saat dan dimatikan sendiri apabila anda selesai.",
  },
  before: {
    title: "Sebelum anda mula: pemuat naik web lebih pantas",
    body: "Pemuat naik web ialah cara standard untuk memuat naik, pada semua pelan.",
    points: [
      { id: "parallel", text: "Ia menghantar banyak foto serentak, jauh lebih banyak daripada aplikasi FTP seperti FileZilla (2 serentak secara lalai, dan tidak lebih daripada 10)." },
      { id: "adaptive", text: "Ia menyesuaikan diri dengan sambungan anda, untuk menggunakannya sepenuhnya." },
      { id: "live", text: "Pratonton dihantar dahulu, jadi galeri anda dalam talian dalam beberapa minit sementara fail asal menyusul." },
      { id: "resume", text: "Jika sambungan anda terputus, ia bersambung semula dengan sendirinya." },
    ],
    button: "Buka pemuat naik web",
    link: "Lihat pemuat naik web yang baharu",
  },
  what: {
    heading: "Pelayan FTP anda sendiri, apabila anda memerlukannya",
    body: "Setiap ahli ruang kerja anda boleh memulakan pelayan FTP mereka sendiri daripada pemuat naik web, pada semua pelan. Setiap orang mendapat pelayan sendiri, pada alamat peribadi yang tidak pernah berubah, jadi anda hanya perlu menyediakan aplikasi FTP anda sekali. Tiada apa-apa yang berjalan apabila anda tidak menggunakannya: ia dimatikan sendiri selepas sejam tanpa aktiviti.",
    date: "1 November 2026",
    closing: "Pelayan FTP kongsi kami yang sentiasa aktif akan ditutup pada 1 November 2026. Menggunakannya sekarang? Mulakan pelayan anda sendiri dan tukar hos dalam aplikasi FTP anda.",
  },
  steps: {
    heading: "Cara ia berfungsi",
    subtitle: "Empat langkah pada kali pertama. Selepas itu, mulakan pelayan anda dan muat naik.",
    items: [
      { id: "open", title: "Buka pemuat naik web", body: "Pergi ke `upload.photohawk.com` dan log masuk, atau buka tab «Upload» sesebuah galeri." },
      { id: "start", title: "Mulakan pelayan anda", body: "Klik «FTP server» di bahagian atas, kemudian «Start FTP server». Ia sedia dalam kira-kira 30 saat." },
      { id: "connect", title: "Salin alamat dan butiran log masuk ke dalam aplikasi FTP anda", body: "Alamat anda, port 21, e-mel dan kata laluan Photohawk anda. Alamat itu tidak pernah berubah." },
      { id: "upload", title: "Muat naik", body: "Tambah foto anda ke dalam folder galeri. Ia dimatikan selepas sejam tanpa sebarang muat naik." },
    ],
    button: "Mulakan pelayan FTP anda",
    buttonNote: "Membuka pemuat naik web dengan pelayan FTP anda sedia untuk dimulakan.",
  },
  panel: {
    heading: "Apa yang anda akan lihat",
    body: "Semuanya ada dalam panel «Your FTP server» dalam pemuat naik web, dengan butang salin di sebelah setiap butiran.",
    points: [
      { id: "address", text: "Alamat anda, seperti `swift-heron-4821.ftp.photohawk.com`. Ia milik anda untuk selamanya, jadi anda hanya perlu menyediakannya sekali." },
      { id: "ip", text: "Alamat IP pelayan juga dipaparkan. Ia berubah setiap kali anda memulakan pelayan, jadi gunakan alamat itu jika boleh." },
      { id: "countdown", text: "Kiraan detik sehingga pelayan dimatikan, dengan «Keep it running» dan «Stop»." },
    ],
    alt: "Panel “Your FTP server” yang menunjukkan Ready di Eropah (Ireland), dengan hos swift-heron-4821.ftp.photohawk.com, alamat IP, port 21, nama pengguna alex@example.com, mod pasif dan FTP melalui TLS, serta kiraan detik dengan butang Keep it running dan Stop.",
  },
  details: {
    heading: "Butiran sambungan anda",
    subtitle: "Masukkan butiran ini dalam aplikasi FTP anda.",
    rows: [
      { id: "host", label: "Hos", value: "Alamat anda, cth. `swift-heron-4821.ftp.photohawk.com` (atau alamat IP yang dipaparkan)" },
      { id: "port", label: "Port", value: "21" },
      { id: "user", label: "Nama pengguna", value: "E-mel Photohawk anda" },
      { id: "password", label: "Kata laluan", value: "Kata laluan Photohawk anda, atau kata laluan FTP anda (di bawah)" },
      { id: "mode", label: "Mod pemindahan", value: "Pasif" },
      { id: "encryption", label: "Penyulitan", value: "FTP biasa, atau FTPS (FTP eksplisit melalui TLS). Untuk FTPS, gunakan nama hos, bukan alamat IP." },
    ],
    switching: "Pernah menggunakan FTP Photohawk? Kekalkan nama pengguna, kata laluan dan folder anda. Hanya tukar hos kepada alamat baharu anda.",
  },
  password: {
    heading: "Kata laluan khas FTP, jika anda mahu",
    body: "Daripada menyimpan kata laluan Photohawk anda dalam aplikasi FTP, klik «Create FTP password» dalam panel. Ia hanya berfungsi pada pelayan FTP anda, dengan e-mel anda sebagai nama pengguna. Anda boleh menyalinnya, membuat yang baharu (yang lama berhenti berfungsi dalam masa seminit) atau membuangnya pada bila-bila masa. Kata laluan Photohawk anda juga terus berfungsi.",
  },
  folders: {
    heading: "Folder anda",
    body: "Anda akan melihat folder yang sama seperti sebelum ini:",
    path: "/Galleries/<gallery>/<collection>",
    points: [
      { id: "single", text: "Galeri dengan satu koleksi hanyalah `/Galleries/<gallery>`." },
      { id: "workspaces", text: "Memuat naik ke lebih daripada satu ruang kerja? Setiap satu mempunyai folder sendiri, dengan galerinya di dalam." },
      { id: "create", text: "Cipta galeri dan koleksinya dalam Photohawk dahulu. Foto anda muncul dalam galeri dalam beberapa saat, sama seperti dengan pemuat naik web." },
    ],
  },
  off: {
    heading: "Ia dimatikan sendiri",
    body: "Pelayan anda dimatikan selepas 1 jam tanpa aktiviti, jadi tiada apa-apa yang perlu diingat. Panel menunjukkan kiraan detik.",
    points: [
      { id: "keep", text: "«Keep it running» memulakan semula kiraan detik tanpa memuat naik apa-apa." },
      { id: "stop", text: "«Stop» mematikannya serta-merta apabila anda selesai." },
      { id: "caps", text: "Untuk keselamatan, ia juga dimatikan selepas 12 jam tanpa sebarang muat naik, dan selewat-lewatnya selepas 24 jam." },
      { id: "again", text: "Mulakan semula bila-bila masa anda mahu, dengan alamat dan butiran log masuk yang sama." },
    ],
  },
  regions: {
    heading: "Rantau",
    body: "Jalankan pelayan anda di Eropah (Ireland), Timur AS (N. Virginia) atau Asia Pasifik (Malaysia). Rantau yang terdekat dipilih untuk anda, dan anda boleh menukarnya sebelum bermula.",
  },
  filezilla: {
    heading: "Contoh: menyediakan FileZilla",
    subtitle: "Aplikasi FTP lain menggunakan tetapan yang sama, kadangkala dengan nama yang sedikit berbeza.",
    steps: [
      { id: "site", text: "Buka «File → Site Manager» dan klik «New site»." },
      { id: "protocol", text: "Protokol: «FTP – File Transfer Protocol»." },
      { id: "host", text: "Hos: alamat anda, cth. `swift-heron-4821.ftp.photohawk.com`. Port: `21`." },
      { id: "tls", text: "Penyulitan: «Use explicit FTP over TLS if available»." },
      { id: "login", text: "Jenis log masuk: «Normal». Pengguna: e-mel Photohawk anda. Kata laluan: kata laluan FTP atau kata laluan Photohawk anda." },
      { id: "passive", text: "Pada tab «Transfer Settings», pilih «Passive». Klik «Connect», kemudian buka `Galleries`." },
    ],
    tip: "Menghantar folder yang besar? FileZilla menghantar 2 fail serentak secara lalai, dan tidak lebih daripada 10. Anda boleh menaikkan tetapan pemindahan serentaknya sehingga 10 («Settings → Transfers»), atau gunakan pemuat naik web, yang menghantar lebih banyak lagi serentak.",
  },
  trouble: {
    heading: "Jika ada yang tidak berfungsi",
    items: [
      { id: "connect", title: "Tidak dapat menyambung", body: "Pastikan panel menunjukkan «Ready». Jika nama hos baru sahaja dicipta, gunakan alamat IP selama seminit." },
      { id: "listing", title: "Sudah bersambung, tetapi senarai folder tergantung", body: "Hidupkan mod pasif." },
      { id: "logins", title: "“Too many failed logins”", body: "Tunggu 15 minit, kemudian semak nama pengguna (e-mel anda) dan kata laluan." },
    ],
  },
  faq: {
    heading: "Soalan",
    items: [
      {
        q: "Mengapa pelayan saya dimatikan?",
        a: "Ia dimatikan selepas sejam tanpa aktiviti, jadi ia tidak pernah berjalan apabila anda tidak menggunakannya. Mulakan semula bila-bila masa: alamat dan butiran log masuk kekal sama. Untuk memastikannya terus berjalan tanpa memuat naik, klik «Keep it running». Ia juga dimatikan selepas 12 jam tanpa sebarang muat naik, dan selewat-lewatnya selepas 24 jam.",
      },
      {
        q: "Bolehkah dua orang menjalankan pelayan serentak?",
        a: "Boleh. Setiap orang dalam ruang kerja anda boleh memulakan pelayan sendiri, satu seorang, pada alamat masing-masing. Hanya anda yang boleh log masuk ke pelayan anda.",
      },
      {
        q: "Adakah ia selamat?",
        a: "Ya. Dengan FTPS (FTP melalui TLS) pada nama hos anda, sambungan disulitkan dengan sijil yang dipercayai. Hanya butiran log masuk anda yang berfungsi pada pelayan anda, dan selepas beberapa kali log masuk gagal, pelayan menyekat sambungan itu selama 15 minit.",
      },
      {
        q: "Adakah saya perlu membayar lebih?",
        a: "Tidak. Pelayan FTP anda sendiri termasuk dalam semua pelan.",
      },
      {
        q: "Adakah ia tersedia pada semua pelan?",
        a: "Ya, termasuk Lite. Untuk muat naik harian, pemuat naik web atau Photohawk Studio lebih pantas; pelayan FTP anda sendiri sedia apabila FTP amat diperlukan.",
      },
      {
        q: "Apa akan berlaku kepada FTP kongsi yang lama?",
        a: "Pelayan FTP kongsi yang sentiasa aktif akan ditutup pada 1 November 2026, dan berfungsi seperti biasa sehingga itu. Untuk terus menggunakan FTP, mulakan pelayan anda sendiri dan tukar hos dalam aplikasi FTP anda kepada alamat baharu anda. Nama pengguna, kata laluan dan folder anda kekal sama.",
      },
    ],
  },
  cta: {
    heading: "Sedia bila-bila masa anda sedia",
    body: "Untuk muat naik harian, gunakan pemuat naik web. Apabila FTP amat diperlukan, pelayan anda sendiri hanya satu klik sahaja.",
    primary: "Buka pemuat naik web",
    secondary: "Mulakan pelayan FTP anda",
  },
};

export default ms;
